/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

export type OrderLimitConstraintType = typeof OrderLimitConstraintType[keyof typeof OrderLimitConstraintType];


export const OrderLimitConstraintType = {
  order_limit: 'order_limit',
} as const;
